<template>
  <div id="hub-event">
    <filters />
    <list />
  </div>
</template>

<script>
import Filters from "./components/Filters";
import List from "./components/List";

export default {
  name: "HubEvent",
  components: {
    List,
    Filters,
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has("post_tag")) {
      let tag = this.$store.getters.getTagByTermID(urlParams.get("post_tag"));

      if (tag.length == 1) {
        this.$store.commit("ADD_TAG", [tag[0].name, tag[0].term_id]);
      }
    }

    this.$store.dispatch("buildIndex");

    this.$store.dispatch("newRequest");
  },
};
</script>
